export default __webpack_public_path__ + "static/media/laconic_main_large.86613e3b.jpg";